import CalendarMovementController from "@/controllers/calendarMovementController";
import InsuranceCarriersMixin from "@/shared/mixins/sdi/insuranceCarriersMixin";
import MovementRecordsMixin from "../movementRecords/movementRecordsMixin";
import ContractsMixin from "../sdi/contractsMixin";
import { mapGetters, mapMutations, mapState } from "vuex";

export default {
  name: "CalendarMovementMixin",

  data: () => ({
    showConfirmationModal: false,
    descriptionMessage: "",
    persistMessage: "\
      Tente mais tarde!<br><br>\
      Se persistir, entre em contato com o suporte técnico.",
    creating: false,
    action: null,
    duplicates: [],
    itemsPerPage: 25,
    sort: "id,desc",
    totalPages: 1,
    page: 1,
    model: [],
  }),

  mixins: [
    CalendarMovementController,
    InsuranceCarriersMixin,
    MovementRecordsMixin,
    ContractsMixin,
  ],

  methods: {
    ...mapMutations({
      newCalendarConfigurationForm: "calendar-movement/newCalendarConfigurationForm",
      removeFormConfiguration: "calendar-movement/removeFormConfiguration",
      cloneFormConfiguration: "calendar-movement/cloneFormConfiguration",
      setCalendarMovements: "calendar-movement/setCalendarMovements",
      cleanContractIds: "calendar-movement/cleanContractIds",
      displayLoading: "calendar-movement/displayLoading",
      setFormField: "calendar-movement/setFormField",
      setNewConfig: "calendar-movement/setNewConfig",
      displayForm: "calendar-movement/displayForm",
      resetModule: "calendar-movement/resetModule",
      resetForm: "calendar-movement/resetForm",

      setContracts: "contract/setContracts",
    }),

    async search(filter) {
      try {
        this.resetForm();

        const params = new URLSearchParams({
          page: this.page-1,
          size: this.itemsPerPage,
          sort: !!this.sort ? this.sort : "id,desc"
        });

        if (filter && filter.carrierId)
          params.append("carrierId", filter.carrierId);

        const result = await this.serviceResponse(this.get(params));

        if (!result || !result.data || !result.data.content) {
          this.setCalendarMovements([]);
          return;
        }

        const data = result.data.content;
        this.totalPages = result.data.totalElements;

        this.setCalendarMovements(data);

      } catch(err) {
        this.calendarMovementViewReference.SnackbarCustomize.open(
          "error",
          `Erro ao buscar as configurações de Calendário.<br>\
          ${this.persistMessage}`
        );

        console.error(err);
      }
    },

    async getConfigs() {
      try {
        this.displayLoading(true);

        let configs = [];

        let result = await this.serviceResponse(this.getConfigsByCalendarId(this.calendarForm.id), true);

          result = result.data.map((res) => this.normalizeCalendarConfig({
            ...res,
            calendarId: this.calendarForm.id,
          }));

          configs = result;

        this.displayLoading(false);

        this.setFormField({configs: configs});
      } catch(err) {
        this.calendarMovementViewReference.SnackbarCustomize.open(
          "error",
          `Erro ao buscar as configurações deste Calendário.<br>\
          ${this.persistMessage}`
        );

        console.error(err);
      }
    },

    async getContractsByCarrierId(carrierId) {
      this.displayLoading(true);
      await this.contractService.FindAllContractsByCarrierId(carrierId).then((response) => {
        if (response && response.data) {
          this.setFormField({contractsByCarrier: response.data});
        }
      }).catch(() => {
        this.calendarMovementViewReference.SnackbarCustomize.open(
          "error",
          `Erro ao buscar contratos dessa operadora.<br>\
          ${this.persistMessage}`
        );
      }).finally(() => {
        this.displayLoading(false);
      });
    },

    async getContracts() {
      const contracts = await this.loadAllContracts();
      this.setContracts(contracts);
    },

    async saveForm() {
      if (
        !this.$refs.CalendarMovementForm.validate()
        || !this.validateIfMovementTypesAreEmpty()
        || !this.validateIfMovementWindowAreEmpty()
        || !this.validateIfHasConfigs()
        || !this.validateHasMovementTypesDuplicated()
      ) return;

      const { contractsByCarrier, ...form} = this.calendarForm;
      if (!this.calendarForm.id) {
        await this.postCalendarForm(form);
      } else {
        await this.serviceResponse(this.put(form.id, form)
        .then((res) => res.data)
        .then((res) => {
          this.calendarMovementViewReference.SnackbarCustomize.open(
            "success", "Configuração de Calendário atualizada!"
          );
        }));
      }

      this.$refs.CalendarMovementForm.resetValidation();
      this.displayForm(false);

      await this.search();
    },

    async postCalendarForm(form) {
      await this.serviceResponse(this.post(form)
      .then((res) => res.data)
      .then((res) => {
        this.calendarMovementViewReference.SnackbarCustomize.open(
          "success", "Configuração de Calendário criada!"
        );
      })
      .catch((err) => console.error(err)));
    },

    async deleteCalendarMovement() {
      try {
        await this.serviceResponse(this.delete(this.calendarForm.id)
        .then((res) => res.data)
        .then((res) => {
          this.calendarMovementViewReference.SnackbarCustomize.open(
            "success",
            "Configuração deletada!"
          );
        }));

        this.displayForm(false);

        await this.search();
      } catch(err) {
        this.calendarMovementViewReference.SnackbarCustomize.open(
          "error",
          `Erro ao tentar excluir configuração.<br>\
          ${this.persistMessage}`
        );

        console.error(err);
      }
    },

    async serviceResponse(requestFunction, notUseLoader) {
      try {
        if (!notUseLoader) this.displayLoading(true);

        return await requestFunction
          .then((response) => response)
          .catch((err) => console.error(err));
      } catch(err) {
        console.error(err);
      } finally {
        if (!notUseLoader) this.displayLoading(false);
      }
    },

    validateIfHasConfigs() {
      const hasConfig = this.calendarForm.configs && this.calendarForm.configs.length > 0;

      if (!hasConfig) {
        this.calendarMovementViewReference.SnackbarCustomize.open(
          "error",
          `Para prosseguir, adicione ao menos uma configuração.`
        );

        return false;
      }

      return true;
    },

    validateIfMovementTypesAreEmpty() {
      const movementTypesEmpty = Array.isArray(this.calendarForm.configs)
        && this.calendarForm.configs.some((config) => config.movementTypes.length === 0);

      if (movementTypesEmpty) {
        this.calendarMovementViewReference.SnackbarCustomize.open(
          "error",
          `Adicione ao menos um tipo de movimentação em suas configurações.`
        );

        return false;
      }

      return true;
    },

    validateIfMovementWindowAreEmpty() {
      const movementWindowEmpty = Array.isArray(this.calendarForm.configs)
        && this.calendarForm.configs.some((config) => !this.hasMovementWindowSelected(config));

      if (movementWindowEmpty) {
        this.calendarMovementViewReference.SnackbarCustomize.open(
          "error",
          `Verifique as suas configurações. Ao menos uma opção da Janela de Movimentaçao precisa estar selecionada.`
        );

        return false;
      }

      return true;
    },

    validateHasMovementTypesDuplicated() {
      this.duplicates = this.setDuplicates();

      if (this.duplicates.length > 0) {
        this.calendarMovementViewReference.SnackbarCustomize.open(
          "error",
          `
            A tipos de movimentações duplicadas.\
            Revise as configurações do Calendário.
          `
        );

        return false;
      }

      return true;
    },

    hasMovementWindowSelected(config) {
      return !!(config?.flFutureWindow || config?.flRetroactiveWindow || config?.flImmediateWindow);
    },

    clearImmediateWindowFields(config) {
      config.flFutureWindow = false;
      config.flRetroactiveWindow = false;
      config.daysOfWindow = null;
      config.flContractCutOffDate = false;
      config.flContractStartDate = false;
      config.specificDays = [];
      config.flDisableEventDate = false;
      config.flUseHolderEventDate = false;
      config.offsetContractStartDate = 0;
      config.flLastDayOfMonth = false;

      return config;
    },

    normalizeCalendarConfig(config) {
      const normalizedConfig = {
        ...config,
        flImmediateWindow: !!config.flImmediateWindow,
        specificDays: Array.isArray(config.specificDays) ? [...config.specificDays] : [],
        flLastDayOfMonth: !!config.flLastDayOfMonth,
      };

      if (normalizedConfig.flImmediateWindow) {
        return this.clearImmediateWindowFields(normalizedConfig);
      }

      if (!normalizedConfig.daysOfWindow) {
        normalizedConfig.daysOfWindow = 120;
      }

      return normalizedConfig;
    },

    cleanSpecificDaysField(item) {
      item.specificDays = [];
      item.flLastDayOfMonth = false;
    },

    sortSpecificDaysField(item) {
      item.specificDays.sort((a, b) => a - b);
    },

    setDuplicates() {
      if (!this.calendarForm.configs || this.calendarForm.configs.length === 0) return [];

      const duplicates = new Map();

      const configsToValidate = this.calendarForm.configs.filter(
        (config) => config.movementTypes && config.movementTypes.length > 0
      );

      const configsByContractId = new Map();
      configsToValidate.forEach((item) => {
        const contractKey = item.contractId ?? null;
        if (!configsByContractId.has(contractKey)) {
          configsByContractId.set(contractKey, []);
        }
        configsByContractId.get(contractKey).push(item);
      });

      configsByContractId.forEach((configs, contractKey) => {
        const seen = new Set();
        configs.forEach((item) => {
          item.movementTypes.forEach((movementTypeCode) => {
            if (seen.has(movementTypeCode)) {
              duplicates.set(`${contractKey}_${movementTypeCode}`, {
                movementTypeCode,
                contractId: contractKey,
              });
            } else {
              seen.add(movementTypeCode);
            }
          });
        });
      });

      return Array.from(duplicates.values());
    },

    setContractDuplicates() {
      if (!this.calendarForm.configs || this.calendarForm.configs.length === 0) return [];

      const seen = new Map();
      const duplicates = new Map();

      const configsToValidate = this.calendarForm.configs.filter(
        (config) => config.movementTypes && config.movementTypes.length > 0
      );

      configsToValidate.forEach((item, index) => {
        const contractIndex = this.calendarForm.contractsByCarrier.findIndex((contract) => contract.id === item.contractId)

        if (seen.has(item.contractId)) {
          seen.get(item.contractId).push(contractIndex);
          duplicates.set(item.contractId, seen.get(item.contractId));
        } else {
          seen.set(item.contractId, [contractIndex]);
        }
      });

      return Array.from(duplicates.entries()).map(([contractId]) => contractId);
    },

    chipDuplicates(movementTypeCode, item) {
      if (!item || !item.movementTypes) return false;

      const duplicates = this.duplicatesMap;
      const normalizedContractId = item.contractId ?? null;

      const movementTypeDuplicated = duplicates.find(
        (dup) => dup.movementTypeCode === movementTypeCode && dup.contractId === normalizedContractId
      );

      if (!movementTypeDuplicated) return false;

      return item.movementTypes.includes(movementTypeCode);
    },

    validateContractId(contractId) {
      const duplicates = this.setContractDuplicates();

      const contractIdDuplicate = duplicates.some((dup) => dup === contractId)

      if (!contractIdDuplicate) return true;
      

      return !contractIdDuplicate;
    },

    async confirmAction() {
      await this.action();
    },

    cloneConfig(config) {
      this.cloneFormConfiguration(config);

      this.calendarMovementViewReference.SnackbarCustomize.open(
        "success", "Configuração duplicada!"
      );
    },

    addNewConfig() {
      this.setNewConfig();

      this.calendarMovementViewReference.SnackbarCustomize.open(
        "success", "Nova Configuração adicionada!"
      );
    },

    removeConfig(config) {
      this.removeFormConfiguration(config);

      this.calendarMovementViewReference.SnackbarCustomize.open(
        "success", "Configuração removida!"
      );
    },

    requestDeleteCalendarMovement() {
      this.setModalAction(() => this.deleteCalendarMovement());
      this.setRemoveMessage();
      this.openConfirmationFormModal();
    },

    setModalAction(functionAction) {
      this.action = functionAction;
    },

    setRemoveMessage() {
      this.descriptionMessage = "Ao confirmar, você estara excluindo essa configuração.<br><br>Deseja prosseguir?";
    },

    openConfirmationFormModal() {
      this.$refs.CalendarFormModal.open();
    },

    openNewForm() {
      this.newCalendarConfigurationForm();
      this.displayForm(true);
    }
  },

  computed: {
    ...mapGetters({
      calendarMovements: "calendar-movement/calendarMovements",
      calendarForm: "calendar-movement/calendarForm",
      showForm: "calendar-movement/showForm",
      loading: "calendar-movement/loading",

      carriers: "insurance-carrier/insuranceCarriers",

      movementContracts: "contract/contracts",
      movTypes: "movement-type/movementTypes",
    }),

    calendarMovementViewReference() {
      return this.$parent.$parent.$refs;
    },

    hasConfig() {
      const configs = this.form.configs;

      return configs.length === 1
    },

    duplicatesMap() {
      return this.setDuplicates();
    },
  },
};
